<template>
    <div>
        <div class="min-h-screen">
            <div class="min-h-screen relative"
                 style="background-image: url('/storage/img/body-background.jpg');background-size:cover;z-index:1;">
                <div class="absolute min-h-screen w-full bg-slate-900/50 h-full" style="z-index: -1;"></div>


                <nav class="bg-gray-800 w-full">
                    <!-- Primary Navigation Menu -->
                    <div class="px-4 sm:px-6 lg:px-8">
                        <div class="flex flex-wrap justify-between items-center h-16">
                            <div class="flex flex-wrap">
                                <!-- Logo -->
                                <div class="flex-shrink-0 flex items-center">
                                    <Link :href="route('dashboard')">
                                        <BreezeApplicationLogo class="block h-9 w-auto"/>
                                    </Link>
                                </div>

                                <!-- Navigation Links -->
                                <div class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                                    <BreezeNavLink :href="route('dashboard')" :active="route().current('dashboard')">
                                        Painel de controlo
                                    </BreezeNavLink>
                                    <BreezeNavLink :href="route('orders.create')"
                                                   :active="route().current('orders.create')">
                                        Encomendar
                                    </BreezeNavLink>
                                    <BreezeNavLink :href="route('orders.list', '1,2,3,4,5')"
                                                   :active="route().current('orders.list', '1,2,3,4,5')">
                                        Encomendas
                                    </BreezeNavLink>
                                    <BreezeNavLink :href="route('payments.index', 'PaymentQ')"
                                                   :active="route().current('payments.index')">
                                        Pagamentos
                                    </BreezeNavLink>
                                    <BreezeNavLink :href="route('articles')" :active="route().current('articles')">
                                        Artigos
                                    </BreezeNavLink>
                                </div>
                            </div>

                            <div class="hidden sm:flex sm:items-center sm:ml-6">
                                <!-- Settings Dropdown -->
                                <div class="ml-3 relative">
                                    <BreezeDropdown align="right" width="48">
                                        <template #trigger>
                                        <span class="inline-flex rounded-md">
                                            <button type="button"
                                                    class="inline-flex items-center px-3 py-2 text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium ubuntu">
                                                {{ $page.props.auth.user.name }}

                                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd"
                                                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                          clip-rule="evenodd"/>
                                                </svg>
                                            </button>
                                        </span>
                                        </template>

                                        <template #content>
                                            <BreezeDropdownLink :href="route('dashboard')" as="button">
                                                Painel de controlo
                                            </BreezeDropdownLink>
                                            <BreezeDropdownLink :href="route('orders.create')" as="button">
                                                Encomendar
                                            </BreezeDropdownLink>
                                            <BreezeDropdownLink :href="route('orders.list', '1,2,3,4,5')" as="button">
                                                Encomendas
                                            </BreezeDropdownLink>
                                            <BreezeDropdownLink :href="route('payments.index', 'PaymentQ')" as="button">
                                                Pagamentos
                                            </BreezeDropdownLink>
                                            <BreezeDropdownLink :href="route('articles')" as="button">
                                                Artigos
                                            </BreezeDropdownLink>
                                            <BreezeDropdownLink :href="route('logout')" method="post" as="button">
                                                Log Out
                                            </BreezeDropdownLink>
                                        </template>
                                    </BreezeDropdown>
                                </div>
                            </div>

                            <!-- Hamburger -->
                            <div class="-mr-2 flex items-center sm:hidden">
                                <button @click="showingNavigationDropdownAnimation"
                                        class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                        <path
                                            :class="{'hidden': showingNavigationDropdown, 'inline-flex': ! showingNavigationDropdown }"
                                            stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M4 6h16M4 12h16M4 18h16"/>
                                        <path
                                            :class="{'hidden': ! showingNavigationDropdown, 'inline-flex': showingNavigationDropdown }"
                                            stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Responsive Navigation Menu -->
                    <div
                        :class="{'block': showingNavigationDropdown, 'hidden': ! showingNavigationDropdown}"
                        class="sm:hidden">
                        <div class="pt-2 pb-3 space-y-1">
                            <BreezeResponsiveNavLink :href="route('dashboard')" :active="route().current('dashboard')">
                                Painel de controlo
                            </BreezeResponsiveNavLink>
                            <BreezeResponsiveNavLink :href="route('orders.create')"
                                                     :active="route().current('orders.create')">
                                Encomendar
                            </BreezeResponsiveNavLink>
                            <BreezeResponsiveNavLink :href="route('orders.list', '1,2,3,4,5')"
                                                     :active="route().current('orders.list', '1,2,3,4,5')">
                                Encomendas
                            </BreezeResponsiveNavLink>
                            <BreezeResponsiveNavLink :href="route('payments.index', 'PaymentQ')"
                                                     :active="route().current('payments.index')">
                                Pagamentos
                            </BreezeResponsiveNavLink>
                            <BreezeResponsiveNavLink :href="route('articles')" :active="route().current('articles')">
                                Artigos
                            </BreezeResponsiveNavLink>
                        </div>

                        <!-- Responsive Settings Options -->
                        <div class="pt-4 pb-1 border-t border-gray-200">
                            <div class="px-4">
                                <div class="font-medium text-base text-gray-800">{{ $page.props.auth.user.name }}</div>
                                <div class="font-medium text-sm text-gray-500">{{ $page.props.auth.user.email }}</div>
                            </div>

                            <div class="mt-3 space-y-1">
                                <BreezeResponsiveNavLink :href="route('logout')" method="post" as="button">
                                    Log Out
                                </BreezeResponsiveNavLink>
                            </div>
                        </div>
                    </div>
                </nav>

            <!-- Page Heading -->
            <header class="bg-gray-800" v-if="$slots.header">
                <div class="text-white mx-auto pt-0 -mt-1 px-10 sm:px-20 xl:px-32 2xl:px-40">
                    <slot name="header" />
                </div>
            </header>
                <div class="absolute bg-gray-800 shadow h-14 w-full" style="z-index:-1;">&nbsp;</div>
                <!-- Page Content -->
                <main>
                    <slot/>
                </main>
            </div>


        </div>
    </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue'
import BreezeDropdown from '@/Components/Dropdown.vue'
import BreezeDropdownLink from '@/Components/DropdownLink.vue'
import BreezeNavLink from '@/Components/NavLink.vue'
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue'
import {Link} from '@inertiajs/inertia-vue3';

export default {
    components: {
        BreezeApplicationLogo,
        BreezeDropdown,
        BreezeDropdownLink,
        BreezeNavLink,
        BreezeResponsiveNavLink,
        Link,
    },
    methods: {
        showingNavigationDropdownAnimation() {
            this.showingNavigationDropdown = ! this.showingNavigationDropdown;
        }
    },
    data() {
        return {
            showingNavigationDropdown: false
        }
    },
}
</script>
